module.exports = __webpack_public_path__ + "img/announcement-icon.1fc778c7.png";